import Api from "./Api";
import moment from "moment";

export default {
  getData: function(typescsv) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}masterrecord/${typescsv}?${t}`;
      Api.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRoleTasksMasterMappings() {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}roletasks`;
      Api.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
